import { QuestionCircleOutlined, LogoutOutlined } from '@ant-design/icons';

import { SelectLang as UmiSelectLang } from '@umijs/max';
import { history } from '@umijs/max';
import { Tooltip } from 'antd';
import { HomeOutlined, AlignCenterOutlined, SkinOutlined } from '@ant-design/icons';
import { Dropdown, Button, MenuProps } from 'antd';
import { useTheme } from '@/context/ThemeContext';
export type SiderTheme = 'light' | 'dark';

export const SelectLang: React.FC = () => {
  return (
    <UmiSelectLang
      style={{
        padding: 4,
      }}
    />
  );
};

export const Question: React.FC = () => {
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};

export const Logout: React.FC = () => {
  const handleLogout = () => {
    localStorage.clear();
    history.push('/user/login');
  };

  return (
    <Tooltip title="退出">
      <a
        onClick={handleLogout}
        style={{
          display: 'inline-flex',
          padding: '4px',
          fontSize: '18px',
          color: 'inherit',
          cursor: 'pointer',
        }

        }
      >
        <LogoutOutlined />
      </a>
    </Tooltip>
  );
};

interface HomePageProps {
  HomePageUrl: string;
}

export const HomePage: React.FC<HomePageProps> = ({ HomePageUrl }) => {
  const handleHomePage = () => {
    history.push(HomePageUrl)
  };
  return (
    <Tooltip title="主页">
      <a onClick={handleHomePage}
        style={{
          display: 'inline-flex',
          padding: '4px',
          fontSize: '18px',
          color: 'inherit',
          cursor: 'pointer',

        }}
      ><HomeOutlined /></a>
    </Tooltip>
  )
}

export const ThemeSwitcher: React.FC = () => {
  const { themeName, setThemeName } = useTheme();
  const items: MenuProps['items'] = [
    { key: 'macOS', label: '淡色主题' },
    //{ key: 'xp', label: 'XP主题' },
    { key: 'ubuntu', label: '像素主题' },
    { key:'win31',label:'经典主题'},
  ];
  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
    setThemeName(key as any);
  };

  return (
    <Dropdown menu={{ items, onClick: handleMenuClick }} placement="bottomRight">
      <SkinOutlined />
    </Dropdown>
  );
};